/**
 * Product tabs
 */

function initialiseProductTabs() {
  const productTabs = document.querySelector('.product-tabs__tab-list');
  if (!productTabs) {
    return;
  }

  productTabs.addEventListener('click', handleProductTabsClick);

  function handleProductTabsClick(event) {
    const tab = event.target.closest('.product-tabs__tab');
    if (!tab) {
      return;
    }
    const tabPanel = document.querySelector(
      `#${tab.getAttribute('aria-controls')}`
    );
    if (!tabPanel) {
      return;
    }
    const allTabs = document.querySelectorAll('.product-tabs__tab');
    const allTabPanels = document.querySelectorAll('.product-tabs__item');

    allTabs.forEach(currentTab => {
      currentTab.classList.remove('active');
      currentTab.removeAttribute('aria-selected');
    });
    allTabPanels.forEach(currentTabPanel => currentTabPanel.classList.remove('active'));

    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');
    tabPanel.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', initialiseProductTabs);
document.addEventListener('shopify:section:load', initialiseProductTabs);
